import { render, staticRenderFns } from "./DescriptiveTags.vue?vue&type=template&id=a798e078&"
import script from "./DescriptiveTags.vue?vue&type=script&lang=js&"
export * from "./DescriptiveTags.vue?vue&type=script&lang=js&"
import style0 from "./DescriptiveTags.vue?vue&type=style&index=0&id=a798e078&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports